"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _uniq = _interopRequireDefault(require("lodash/uniq"));

var _Container = _interopRequireDefault(require("./Container"));

var _standardizeConfig3 = _interopRequireDefault(require("./standardizeConfig"));

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ServiceProvider = /*#__PURE__*/function () {
  function ServiceProvider(config) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$services = _ref.services,
        services = _ref$services === void 0 ? {} : _ref$services,
        _ref$defaults = _ref.defaults,
        defaults = _ref$defaults === void 0 ? {} : _ref$defaults,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? {} : _ref$disabled;

    (0, _classCallCheck2["default"])(this, ServiceProvider);
    this._config = config; // all the service classes that this provider should support

    this._services = services; // the services (as string names) that should be used for each role by
    // default, or when that role is disabled

    this._resolver = {
      defaults: defaults,
      disabled: disabled
    };
  }
  /**
   * @param {string} serviceName
   * @returns {boolean}
   */


  (0, _createClass2["default"])(ServiceProvider, [{
    key: "supports",
    value: function supports(serviceName) {
      return !!this._services[serviceName];
    }
    /**
     * @param {object} servicesConfig
     * @returns {Container}
     */

  }, {
    key: "buildContainer",
    value: function buildContainer() {
      var container = new _Container["default"]();

      for (var role in this._config) {
        var _standardizeConfig = (0, _standardizeConfig3["default"])(role, this._config[role], this._resolver),
            _standardizeConfig2 = (0, _slicedToArray2["default"])(_standardizeConfig, 2),
            service = _standardizeConfig2[0],
            settings = _standardizeConfig2[1];

        var instance = void 0; // each config can contain a service descriptor in one of several forms:

        if ((0, _typeof2["default"])(service) == 'object') {
          // instance
          instance = service;
        } else if (typeof service == 'function') {
          // constructor
          instance = new service();
        } else {
          // string
          if (!this.supports(service) && role === 'exchange') {
            throw new Error('This service has been extracted from dai.js. Please refer to the documentation to add it as a plugin: \n\n https://github.com/makerdao/dai.js/wiki/Basic-Usage-(Plugins)');
          }

          if (!this.supports(service)) {
            throw new Error('Unsupported service in configuration: ' + service);
          }

          instance = new this._services[service]();
        }

        var instanceName = instance.manager().name();

        if (instanceName !== role) {
          throw new Error("Role mismatch: \"".concat(instanceName, "\", \"").concat(role, "\""));
        }

        instance.manager().settings(settings);
        container.register(instance, role);
      }

      this._registerDependencies(container);

      container.injectDependencies();
      this._container = container;
      return container;
    }
  }, {
    key: "_registerDependencies",
    value: function _registerDependencies(container) {
      var names = container.getRegisteredServiceNames(); // get the names of all dependencies

      var allDeps = names.reduce(function (acc, name) {
        var service = container.service(name);
        var deps = service.manager().dependencies();
        return (0, _uniq["default"])(acc.concat(deps));
      }, []); // filter out the ones that are already registered

      var newDeps = allDeps.filter(function (name) {
        return !names.includes(name);
      });
      if (newDeps.length === 0) return; // register any remaining ones

      var _iterator = _createForOfIteratorHelper(newDeps),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var name = _step.value;
          var ctor = this._resolver.defaults[name];
          if (typeof ctor === 'string') ctor = this._services[ctor];
          if (!ctor) throw new Error("No service found for \"".concat(name, "\""));
          container.register(new ctor(), name);
        } // repeat, to find any dependencies for services that were just added

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._registerDependencies(container);
    }
  }, {
    key: "service",
    value: function service(name) {
      if (!this._container) this.buildContainer();
      return this._container.service(name);
    }
  }]);
  return ServiceProvider;
}();

exports["default"] = ServiceProvider;